import React, { ReactElement } from 'react'
import { BoxProps } from '@mindfulchefuk/design-system/layout/Box'
import { Svg } from '@mindfulchefuk/design-system'

const VisaIcon = (props: BoxProps): ReactElement => (
  <Svg viewBox="0 0 26 16" {...props}>
    <rect width="26" height="16" rx="2" ry="2" fill="#224dba" />
    <path
      d="M7.91 10.88H6.4L5.26 6.35a.74.74 0 00-.33-.48 4.51 4.51 0 00-1.38-.47v-.18H6a.65.65 0 01.63.57l.57 3.26 1.51-3.83h1.47zm3.11 0H9.59l1.17-5.66h1.43zm3-4.09a.55.55 0 01.59-.48 2.64 2.64 0 011.39.26l.25-1.22A3.43 3.43 0 0015 5.09c-1.38 0-2.39.78-2.39 1.87a1.83 1.83 0 001.21 1.52c.55.26.76.44.72.7a.72.72 0 01-.84.57 3.41 3.41 0 01-1.47-.34l-.25 1.21a3.94 3.94 0 001.55.31C15 11 16 10.18 16 9c0-1.48-2-1.57-2-2.22zm7 4.09l-1.15-5.66h-1.21a.63.63 0 00-.59.44L16 10.88h1.47l.29-.83h1.81l.16.83zm-2.15-4.14l.42 2.13h-1.18z"
      fill="#fff"
    />
  </Svg>
)

export default VisaIcon
